class portfolioFilter
{
    constructor() {
		this.selectElement = '#portfolio-filter';
		this.gridElement = '.portfolio-items';
		this.wpVars = helpers.wpVars;

        const { addEvent, selectElement, handleChanges } = this;

		addEvent( selectElement, 'change', handleChanges.bind(this) );
    }

    /**
	 * @method AddEvent
	 * @param {DomTokenNode | DomTokenList} element // Nodes to bind event
	 * @param {String} event  // Event to bind
	 * @param {String | Function} func // function to use on event
	 *
	 * Helper method to bind events;
	*/

	addEvent(element, event, func) {
		if (element !== window) {
            element = document.querySelectorAll(element);

			element.forEach(el => {
				return el.addEventListener(event, func);
            });

		} else {
			return element.addEventListener(event, func);
		}
	}

	/**
	 * @method showOverlay
	 * @param {String} target
	 *
	 * @description Adds overlay HTML and fades it in
	 *
	*/

	showOverlay(target) {
		let targetDOM = document.querySelector(target);
		let targetInnerHTML = targetDOM.innerHTML;
		let overlayHTML =
		`<div class="ajax-overlay">
			<div class="loadingio-spinner-rolling-j5v8w22xc7s">
				<div class="ldio-ve4o67ja7dd">
					<div></div>
				</div>
				</div>
		</div>`

		targetDOM.innerHTML = `${targetInnerHTML}${overlayHTML}`;

		let spinner = document.querySelector('.ajax-overlay')

		fadeIn(spinner);
	}

	/**
	 * @method hideOverlay
	 * @description Hides overlay and removes node.
	 *
	*/

	hideOverlay() {
		let overlay = document.querySelector('.ajax-overlay');
		fadeOut(overlay, () => {
			overlay.remove();
		});
	}

	/**
	 * @method handleChanges
	 * @param {Object} e | Event handler
	 *
	 * @description Handles change events on selectElement var;
	*/

	handleChanges(e) {

		// destructure settings
		const { showOverlay, gridElement, insertResponseHTML, wpVars, hideOverlay } = this;

		// WP action name
		const action = 'inv_filter_portfolio_items';

		// get value from <select>
		let selectedFilter = {value : e.target.value};

		// Show loading overlay
		showOverlay(gridElement);

		// start promise
		let fetchPosts =  fetchResults(wpVars.adminURL, action, selectedFilter, true);

		/**
		 * handle response.
		*/
		fetchPosts.then(res => {
			const { HTML, status } = res;

			if ( status === 'success' ) {
				insertResponseHTML(res.HTML, document.querySelector(gridElement));

				if ( helpers.isMobile && window.mobileSlider0 !== null ) {
					mobileSlider0.destroy();
					mobileSlider0.rebuild();
				}

			}  else {
				insertResponseHTML('<p class="Não encontramos nenhum item do portfólio com essa categoria :/"></p>', document.querySelector(gridElement))

				if ( helpers.isMobile && window.mobileSlider0 !== null ) {
					console.log(mobileSlider0)
				}
			}

			refreshFsLightbox()

			hideOverlay();
		});
	}

	/**
	 * @method insertResponseHTML
	 * @param {String} html | HTML to insert
	 * @param {DomTokenNode} insertNode | node to insert info into;
	 */

	insertResponseHTML(html, insertNode) {
		insertNode.innerHTML = html;
	}

}